import { IKeyInitiativeForm } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/models/keyInitiativeForm'
import { EKeyInitiativeOutcomeValueType } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/models/keyInitiativeOutcomeItem'
import { TRANSLATION_KEYS as tr } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'

type TPersistedKeyInitiativeOutcomeMetricField = keyof Pick<
  IKeyInitiativeForm,
  'funnelSize' | 'leads' | 'conversionRate' | 'attendance'
>

export type TKeyInitiativeOutcomeMetricField =
  | TPersistedKeyInitiativeOutcomeMetricField
  | 'estimateSales'

export interface IKeyInitiativeOutcomeMetricConfig {
  field: TKeyInitiativeOutcomeMetricField
  labelKey: string
  min?: number
  max?: number
}

const KEYS = tr.keyInitiativeEditor.outcomeFieldGroup

export const KEY_INITIATIVE_OUTCOME_METRIC_FIELDS: IKeyInitiativeOutcomeMetricConfig[] = [
  { field: 'funnelSize', labelKey: KEYS.funnelSize, min: 0 },
  { field: 'conversionRate', labelKey: KEYS.conversionRate, min: 0, max: 100 },
  { field: 'estimateSales', labelKey: KEYS.estimateSales, min: 0 },
  { field: 'leads', labelKey: KEYS.leads, min: 0 },
  { field: 'attendance', labelKey: KEYS.attendance, min: 0 },
]

export interface IKeyInitiativeOutcomeValueTypeConfig {
  value: EKeyInitiativeOutcomeValueType
  labelKey: string
  icon: string
}

export const KEY_INITIATIVE_OUTCOME_VALUE_TYPES: IKeyInitiativeOutcomeValueTypeConfig[] = [
  {
    value: EKeyInitiativeOutcomeValueType.Financial,
    labelKey: KEYS.valueTypes.financial,
    icon: 'kbase kbase-chart',
  },
  {
    value: EKeyInitiativeOutcomeValueType.Number,
    labelKey: KEYS.valueTypes.number,
    icon: 'kbase kbase-editor-ol',
  },
  {
    value: EKeyInitiativeOutcomeValueType.Percentage,
    labelKey: KEYS.valueTypes.percentage,
    icon: 'kbase kbase-lvl-poll',
  },
  {
    value: EKeyInitiativeOutcomeValueType.FreeText,
    labelKey: KEYS.valueTypes.freeText,
    icon: 'kbase kbase-omni-text',
  },
]
